import script from "./Friends.vue?vue&type=script&setup=true&lang=js"
export * from "./Friends.vue?vue&type=script&setup=true&lang=js"

import "./Friends.vue?vue&type=style&index=0&id=f87d731c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f87d731c"]])

export default __exports__